export const filesPreviewBox = {
  height: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  gap: 2,
  justifyContent: 'center',
};

export const dahsedContainer = {
  overflow: 'auto',
  p: 3,
  height: 300,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  borderRadius: 3,
  border: 1.5,
  borderStyle: 'dashed',
  transition: 'all 0.2s ease',
  mb: 3,
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
};

export const fileNameStyle = {
  width: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  textAlign: 'center',
};

export const filePreviewBox = {
  width: 200,
  p: 2,
  border: 1,
  borderColor: 'grey.400',
  borderRadius: 3,
  transition: 'transform 0.2s',
  '&:hover': { transform: 'scale(1.02)' },
};
export const boxStyle = {
  height: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
export const imageStyle = (isImage) => ({
  maxHeight: 100,
  maxWidth: '100%',
  objectFit: isImage ? 'contain' : 'scale-down',
});
